import Constants from './constants'
export default function (apiName, params) {
  let apis = Constants[apiName].split(' ')
  let type = apis[0]

  const urlSplit = apis[1].split(/:[^/]+/)

  let url = ''

  params = params.slice(0)

  urlSplit.forEach((item, index) => {
    let param = params[index] || ''
    url = url + item + param
  })
  return {
    type: type,
    url: url
  }
}
